import Registry from "../registry";
import React from "react";
import JsonEditor from "../components/fields/JsonEditor";
import { truncate } from "../lib/ContentUtils";
import { jsonTransformer } from "../lib/fieldTransformers";
import t from "tcomb-form";

const json = {
  name: "Data",
  group: "Content",
  options: {},
  schema: (part) => ({
    type: "object",
    factory: t.form.Textbox,
    transformer: jsonTransformer,
    component: ({ value, onChange, attrs: { id } }) => {
      console.log(value);
      return <JsonEditor id={id} value={value} onChange={onChange} />;
    },
    render: ({ value }) => {
      return truncate(JSON.stringify(value || "{}"));
    },
  }),
};

Registry.register("json", json);

export default json;



// WEBPACK FOOTER //
// ./app/parts/json.js